import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class DressCacheRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;
		this.updateDressCache = this.updateDressCache.bind(this);
	}

	async updateDressCache(rootId: number | string, dateTime: string) {
		try {
			const root = rootId === "all" ? null : rootId;
			const date = dateTime === "" ? null : dateTime;
			const resp = await this.axios.patch(`/HeatMetric/dress-cache`, {
				rootId,
				date,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const { updateDressCache } = new DressCacheRepository();
